module.exports = __webpack_public_path__ + "static/media/faq-banner.8aa62f6a.jpg";